import axios from '../../axios';
import { GET_FAQ } from '../types';


export const getFaqs = () => async (dispatch) => {
    try {
        const res = await axios.get("faq/get");
        if (res.data.code === 1) {
            dispatch({type: GET_FAQ, payload: res.data.data});
        }
    } catch (err) {
        console.log(err);
    }
};

